import { ColumnSizingState } from '@tanstack/react-table';

import { TABLE_COLUMN_SIZES_STORAGE_KEY_PREFIX } from '../types/table';
import { isRecordOf, readTableStorage } from './tableStorage';

const isColumnSizingState = isRecordOf((size): size is number => typeof size === 'number');

export const getStoredColumnSizes = (columnSizesTableName?: string): ColumnSizingState =>
    readTableStorage(TABLE_COLUMN_SIZES_STORAGE_KEY_PREFIX, columnSizesTableName, isColumnSizingState, {});
